import { Box } from "@mui/material";
import ReactSelect from "../ReactSelect";
import { string, object } from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { selectSelfTestOptions } from "../../../constants";

const SelectFieldForMap = ({ data, onChange }) => {
  console.log("data----->>>>", data);
  const validationSchema = object().shape({
    jobType: string().required("Required"),
  });

  const {
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      jobType: "",
    },
  });

  // Set the default value when 'data' changes
  useEffect(() => {
    if (data) {
      setValue("jobType", data); // Set the default value from the 'data' prop
    }
  }, [data, setValue]);

  // Handle the change in the select field
  const handleSelectChange = (selectedOption) => {
    console.log("Print changed value", selectedOption); // Extract value
    if (selectedOption) {
      setValue("jobType", selectedOption);
      onChange(selectedOption);
    }
  };

  return (
    <Box px={1}>
      <ReactSelect
        hookFormControl={control}
        label="Job Type"
        varName="jobType"
        key={"jobType"}
        options={selectSelfTestOptions}
        onChange={handleSelectChange}
        errorMessage={errors?.jobType?.message}
      />
    </Box>
  );
};

export default SelectFieldForMap;
